import * as SPTYPES from 'constants/spTypes'

export const DATA_VALUE = 'data_value'
export const DESCRIPTION = 'description'
export const ID = 'id'
export const STATUS = 'status'
export const TABLE_DIM_LENGTH = 'table_dim_length'
export const TABLE_DIM_2D_3D = 'table_dim_2d_3d'
export const Z_SIGN = 'z_sign'
export const X_SIGN = 'y_sign'
export const Y_SIGN = 'x_sign'
export const Z_BYTE = 'z_byte'
export const VALUE = 'value'
export const PARAMETER_VERSION = 'parameter_version'
export const Modal_NUMBER = 'Modal_number'
export const LOGICAL_SLOT = 'logical_slot'
export const ROWID = 'rowid'
export const PARM_CHECKSUM_OFFSET = 'parm_checksum_offset'
export const PARM_ADDRESS = 'parm_address'
export const PARM_SIZE = 'parm_size'
export const EXTRA_BLOCK_1_ADDRESS = 'extra_block_1_address'
export const EXTRA_BLOCK_1_SIZE = 'extra_block_1_size'
export const EXTRA_BLOCK_2_ADDRESS = 'extra_block_2_address'
export const EXTRA_BLOCK_2_SIZE = 'extra_block_2_size'
export const EXTRA_BLOCK_3_ADDRESS = 'extra_block_3_address'
export const EXTRA_BLOCK_3_SIZE = 'extra_block_3_size'
export const MODE = 'mode'
export const PRIORITY = 'priority'
export const INVERTED = 'inverted'
export const LENGTH = 'length'
export const OFFSET = 'offset'
export const TYPE = 'type'
export const PHYSICAL_SLOT = 'physical_slot'
export const AI_LS = 'ai_ls'
export const DO_LS = 'do_ls'
export const AI = 'ai'
export const DO = 'do'
export const COMPARE = 'compare'
export const INTERCEPT = 'intercept'
export const REACTION = 'reaction'
export const PC_INC = 'pc_inc'
export const PC_DEC = 'pc_dec'
export const FAULT_INTERCEPT = 'fault_intercept'
export const FAULT_REACTION = 'fault_reaction'
export const FAULT_PC_INC = 'fault_pc_inc'
export const FAULT_PC_DEC = 'fault_pc_dec'
export const DTC_J1587_SID = 'dtc_j1587_sid'
export const DTC_J1939_SPN = 'dtc_j1939_spn'
export const DTC_J1587_FMI = 'dtc_j1587_fmi'
export const DTC_J1939_FMI = 'dtc_j1939_fmi'
export const J1587_SID = 'j1587_sid'
export const J1939_SPN = 'j1939_spn'
export const J1587_FMI = 'j1587_fmi'
export const J1939_FMI = 'j1939_fmi'
export const DTC_REACTION = 'dtc_reaction'
export const ACQUIRE_LOW = 'acquire_low'
export const ACQUIRE_HIGH = 'acquire_high'
export const LOSS_LOW = 'loss_low'
export const LOSS_HIGH = 'loss_high'
export const TASK1 = 'task1'
export const TASK2 = 'task2'
export const TASK3 = 'task3'
export const TASK4 = 'task4'
export const TASK5 = 'task5'
export const TASK6 = 'task6'
export const TASK7 = 'task7'
export const OUTPUT_ID = 'output_id'
export const BEHAVIOR_CODE = 'behavior_code'
export const TEST_TIME = 'test_time'
export const OUTPUT_1 = 'output_1'
export const OUTPUT_2 = 'output_2'
export const OUTPUT_1_CURRENT_SENSE = 'output_1_current_sense'
export const OUTPUT_2_CURRENT_SENSE = 'output_2_current_sense'
export const OUTPUT_1_LOW_LIMIT = 'output_1_low_limit'
export const OUTPUT_2_LOW_LIMIT = 'output_2_low_limit'
export const OUTPUT_1_HIGH_LIMIT = 'output_1_high_limit'
export const OUTPUT_2_HIGH_LIMIT = 'output_2_high_limit'
export const CAN_SLOT = 'can_slot'
export const PGN = 'pgn'
export const ADDRESS = 'address'
export const MESSAGE_ID = 'message_id'
export const BYTE_OFFSET = 'byte_offset'
export const UPDATE_RATE = 'update_rate'
export const RX_TX = 'rx_tx'
export const UNIQUE_ID = 'unique_id'
export const MLOGICSLOTNAME = 'mLogicSlotName'
export const TIMER_SLOT = 'timer_slot'
export const SUPPORTPARAMETERTYPE = 'supportParameterType'
export const ENABLE_CELL_1 = 'enable_cell_1'
export const ENABLE_CELL_2 = 'enable_cell_2'
export const ENABLE_CELL_3 = 'enable_cell_3'
export const SOURCE = 'source'
export const DESTINATION = 'destination'
export const URI = 'uri'
export const OUTPUT_DEFAULT = 'outputDefault'
export const OUTPUT_FALSE = 'outputFalse'
export const OUTPUT_TRUE = 'outputTrue'
export const OUTPUT = 'output'
export const LOGICALSLOT = 'logicalSlot'
export const ACC_BIT = 'acc_bit'
export const IGN_BIT = 'ign_bit'
export const CRANK_BIT = 'crank_bit'
export const ENABLE_BIT = 'enable_bit'
export const PLC_OUTPUT = 'rowid'
export const PLC_IGN_SLOT = 'plc-ign-slot'

const basicProps = [DESCRIPTION, ID, STATUS]
const cFGProperties = [
  ...basicProps,
  TABLE_DIM_LENGTH,
  TABLE_DIM_2D_3D,
  Z_SIGN,
  X_SIGN,
  Y_SIGN,
  Z_BYTE,
]
const basicAndValue = [...basicProps, VALUE]
const statusAndSlot = [STATUS, LOGICAL_SLOT]
const rowStatVal = [ROWID, STATUS, VALUE]
export const mLogicInputs = [
  'E0',
  'E1',
  'E2',
  'E3',
  'E4',
  'E5',
  'C0',
  'C1',
  'C2',
  'C3',
  'C4',
  'C5',
  'C6',
  'C7',
  'C8',
  'C9',
  'C10',
  'C11',
]
export const mLogicInputSet = new Set(mLogicInputs)
export const mLogicOutputs = [OUTPUT_DEFAULT, OUTPUT_FALSE, OUTPUT_TRUE]
export const mLogicOutputSet = new Set(mLogicOutputs)
export const PLC_ENABLE_SET = new Set([
  ENABLE_CELL_1,
  ENABLE_CELL_2,
  ENABLE_CELL_3,
])
export const slotOnlyProps = new Set([SOURCE, DESTINATION, ...PLC_ENABLE_SET])

export const PLC_PROPS = [PLC_IGN_SLOT, ...PLC_ENABLE_SET, PLC_OUTPUT]

export const spPropertyMap = {
  [SPTYPES.O_CAN]: [
    CAN_SLOT,
    STATUS,
    PGN,
    ADDRESS,
    MESSAGE_ID,
    BYTE_OFFSET,
    UPDATE_RATE,
    RX_TX,
  ],
  [SPTYPES.N_CAN]: [
    ROWID,
    STATUS,
    PGN,
    ADDRESS,
    MESSAGE_ID,
    BYTE_OFFSET,
    UPDATE_RATE,
    UNIQUE_ID,
    RX_TX,
  ],
  [SPTYPES.N_APP_DTC]: [
    ROWID,
    STATUS,
    J1939_SPN,
    J1939_FMI,
    J1587_SID,
    J1587_FMI,
    REACTION,
  ],
  [SPTYPES.N_APP_FAULT]: [STATUS, ROWID, PC_INC, PC_DEC],
  [SPTYPES.N_FUEL_LEVEL_DATA]: rowStatVal,
  [SPTYPES.N_FUEL_LEVEL_CFG]: cFGProperties, // x, y, z stuff has default of '0' for this SP type
  [SPTYPES.N_TEMP_LEVEL_CFG]: cFGProperties, // x, y, z stuff has default of '0' for this SP type
  [SPTYPES.N_LIGHTMONITOR]: [
    ROWID,
    STATUS,
    OUTPUT_1,
    OUTPUT_2,
    OUTPUT_1_CURRENT_SENSE,
    OUTPUT_2_CURRENT_SENSE,
    OUTPUT_1_LOW_LIMIT,
    OUTPUT_2_LOW_LIMIT,
    OUTPUT_1_HIGH_LIMIT,
    OUTPUT_2_HIGH_LIMIT,
  ],
  [SPTYPES.N_PREFLIGHT]: [ROWID, STATUS, OUTPUT_ID, BEHAVIOR_CODE, TEST_TIME],
  [SPTYPES.N_PREFLIGHT2]: [STATUS, OUTPUT_ID],
  [SPTYPES.N_PREFLIGHT3]: [ROWID, STATUS, OUTPUT_ID],
  [SPTYPES.N_PRIORITY]: [
    ROWID,
    STATUS,
    TASK1,
    TASK2,
    TASK3,
    TASK4,
    TASK5,
    TASK6,
    TASK7,
  ],
  [SPTYPES.N_SLOTINIT]: [STATUS, VALUE],
  [SPTYPES.N_STALKSWITCH]: [
    ROWID,
    STATUS,
    ACQUIRE_LOW,
    ACQUIRE_HIGH,
    LOSS_LOW,
    LOSS_HIGH,
  ],
  // [SPTYPES.N_SUBCONFIG]: [], The N_SUBCONFIG component is a pretty big ball of wax. The data structure itself has different modes that drive different displays. It needs to be refactored before it will fit in with the changes that have incoporated the rest of these support parameters, but the effort vs. value makes it not worthwhile.
  [SPTYPES.N_SUBDATA]: [STATUS, ROWID, VALUE],
  [SPTYPES.N_SSADDRESS]: rowStatVal,
  [SPTYPES.N_TEMP_LEVEL_DATA]: rowStatVal,
  [SPTYPES.N_USER_DTC]: [
    ROWID,
    STATUS,
    J1939_SPN,
    J1939_FMI,
    J1587_SID,
    J1587_FMI,
    REACTION,
  ],
  [SPTYPES.N_USER_FAULT]: [
    STATUS,
    ROWID,
    AI,
    DO,
    INTERCEPT,
    COMPARE,
    REACTION,
    PC_INC,
    PC_DEC,
  ],
  [SPTYPES.O_FAULT]: [
    ROWID,
    STATUS,
    AI_LS,
    DO_LS,
    COMPARE,
    FAULT_INTERCEPT,
    FAULT_REACTION,
    FAULT_PC_INC,
    FAULT_PC_DEC,
    DTC_J1587_SID,
    DTC_J1939_SPN,
    DTC_J1587_FMI,
    DTC_J1939_FMI,
    DTC_REACTION,
  ],
  [SPTYPES.O_SLOTINIT]: [
    ROWID,
    STATUS,
    MODE,
    PRIORITY,
    INVERTED,
    LENGTH,
    OFFSET,
    TYPE,
    PHYSICAL_SLOT,
  ],
  [SPTYPES.N_ANALOG_SENSOR_8BIT_CFG]: cFGProperties,
  [SPTYPES.N_ANALOG_SENSOR_16BIT_CFG]: cFGProperties,
  [SPTYPES.N_ANALOG_SENSOR_32BIT_CFG]: cFGProperties,
  [SPTYPES.N_EFFORT_CONTROL_CFG]: cFGProperties,
  [SPTYPES.N_ANALOG_SENSOR_8BIT_DATA]: basicAndValue,
  [SPTYPES.N_ANALOG_SENSOR_16BIT_DATA]: basicAndValue,
  [SPTYPES.N_ANALOG_SENSOR_32BIT_DATA]: basicAndValue,
  [SPTYPES.N_EFFORT_CONTROL_DATA]: basicAndValue,
  [SPTYPES.N_RPLOC]: basicAndValue,
  [SPTYPES.N_RPSIZE]: basicAndValue,
  [SPTYPES.N_CANSIZE]: basicAndValue,
  [SPTYPES.N_VIN]: basicAndValue,
  [SPTYPES.N_POWERDOWN]: basicAndValue,
  [SPTYPES.N_VERSION]: [...basicProps, PARAMETER_VERSION],
  [SPTYPES.N_Modal]: [...basicProps, Modal_NUMBER],
  [SPTYPES.S_SLOTINITSLOTS]: statusAndSlot,
  [SPTYPES.S_CANSLOTS]: [ROWID, ...statusAndSlot],
  [SPTYPES.S_MLOGICSLOTS]: [ROWID, ...statusAndSlot],
  [SPTYPES.S_TIMERSLOTS]: [ROWID, ...statusAndSlot],
  [SPTYPES.S_MAPSLOTS]: [ROWID, ...statusAndSlot],
  [SPTYPES.S_MEMORY]: [
    STATUS,
    PARM_CHECKSUM_OFFSET,
    PARM_ADDRESS,
    PARM_SIZE,
    EXTRA_BLOCK_1_ADDRESS,
    EXTRA_BLOCK_1_SIZE,
    EXTRA_BLOCK_2_ADDRESS,
    EXTRA_BLOCK_2_SIZE,
    EXTRA_BLOCK_3_ADDRESS,
    EXTRA_BLOCK_3_SIZE,
  ],
}

export const DEFAULT_TASK_ID = '3'
